module.exports = __webpack_public_path__ + "img/outstandingThankyou.9d3b9a10.svg";